export const config = {
    chainId:56 ,
    networkName:"Binance Smart Chain",
    rpcUrl: "https://bsc-dataseed.binance.org/",
    contractAddress:"0x35BC16E232489Db391AC63Edc7920c556b5C9fbB",
}